/**
 * TOOLTIP COMPONENT
 * 
 * Componente reutilizable para mostrar explicaciones interactivas
 * sobre campos de entrada complejos
 * 
 * Uso:
 * <Tooltip text="Explicación aquí">
 *   <input ... />
 * </Tooltip>
 */

import React, { useState } from 'react'
import { HelpCircle } from 'lucide-react'

export default function Tooltip({ text, children, position = 'top' }) {
  const [showTooltip, setShowTooltip] = useState(false)

  const positionClasses = {
    top: 'bottom-full mb-2 -translate-x-1/2 left-1/2',
    right: 'left-full ml-2 top-1/2 -translate-y-1/2',
    bottom: 'top-full mt-2 -translate-x-1/2 left-1/2',
    left: 'right-full mr-2 top-1/2 -translate-y-1/2'
  }

  return (
    <div className="relative inline-block w-full">
      <div className="flex items-center gap-2">
        {children}
        <div 
          className="flex-shrink-0 relative cursor-help"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={() => setShowTooltip(!showTooltip)}
        >
          <button
            type="button"
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 transition-colors p-1"
            title={text}
          >
            <HelpCircle className="w-4 h-4" />
          </button>

          {/* Tooltip Box - Solo renderizar cuando esté activo */}
          {showTooltip && (
            <div
              className={`
                absolute z-50 px-3 py-2 text-sm font-medium text-white bg-gray-900 
                rounded-lg shadow-lg whitespace-normal
                max-w-xs transition-opacity duration-200
                ${positionClasses[position]}
              `}
            >
              {text}
              {/* Arrow */}
              <div
                className={`
                  absolute w-2 h-2 bg-gray-900 transform rotate-45
                  ${position === 'top' ? 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2' : ''}
                  ${position === 'bottom' ? 'top-0 left-1/2 -translate-x-1/2 -translate-y-1/2' : ''}
                  ${position === 'left' ? 'right-0 top-1/2 -translate-y-1/2 translate-x-1/2' : ''}
                  ${position === 'right' ? 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/2' : ''}
                `}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
